<template>
  <div>
    <div v-if="!withAvilableCart">Shopping Cart empty.</div>
    <div v-else>
      <div>
        <div tabindex="0" class="e-card">
          <div class="e-card-title">Shopping Cart Checkout</div>
          <div style="padding: 20px">
            <div>
              <h4 class="title-color">Order Information</h4>
            </div>
            <div class="e-card-separator"></div>
            <div class="wrap_address">
              <div class="form-row">
                <div style="width: 20%" class="form-row-input">
                  <ejs-numerictextbox
                    float-label-type="Always"
                    placeholder="Total Amount*"
                    format="C2"
                    :showSpinButton="spin"
                    readonly="true"
                    v-model="shoppingCart.totalShoppingAmount"
                  />
                </div>
              </div>
              <div class="form-row">
                <div style="width: 15%">
                  <p style="color: black; font-size: 12px">
                    Available Payment Methods:
                  </p>
                </div>
                <div style="width: 75%" class="form-row">
                  <div
                    style="width: 15%"
                    v-for="(payMethod, index) in paymentMethods"
                    :key="index"
                  >
                    <ejs-radiobutton
                      :label="payMethod.method"
                      :htmlAttributes="{ value: payMethod.method }"
                      v-model="shoppingCart.checkOutMethod"
                      :checked="
                        shoppingCart.checkOutMethod === payMethod.method
                      "
                      name="pmethod"
                    ></ejs-radiobutton>
                  </div>
                </div>
                <div v-if="shoppingCart.totalShoppingAmount>=4000">
                 <p style="color: red; font-size: 12px">
                  Unfortunately, you have exceeded the credit card limit per transaction.
                  <br>You may select EFT or Cheque as a payment type and follow up with
                  our accounting department directly for further
                  information at accounting@safetycodes.ab.ca or 1-888-413-0099
                  </p>
                </div>
              </div>
              <div class="form-row">
                <ejs-grid
                  :dataSource="invoices"
                  ref="refShoppingCartList"
                  enablePersistence="true"
                  :allowSorting="true"
                  :allowPaging="false"
                  :pageSettings="pageSettings"
                  :commandClick="commandClick"
                >
                  <e-columns>
                    <e-column
                      field="invoiceId"
                      headerText="Invoice ID"
                      textAlign="Left"
                      :isPrimaryKey="true"
                      width="0"
                    ></e-column>
                    <e-column
                      headerText="Remove"
                      :commands="commands"
                      textAlign="Left"
                      width=" 10%"
                    ></e-column>
                    <e-column
                      field="invoiceSourceType"
                      headerText="Invoice Type"
                      textAlign="Left"
                      width="15%"
                    ></e-column>
                    <e-column
                      field="status"
                      headerText="Status"
                      textAlign="Left"
                    ></e-column>
                    <e-column
                      field="invoiceNumber"
                      headerText="Invoice Number"
                      textAlign="Left"
                    ></e-column>
                    <e-column
                      field="totalAmount"
                      headerText="Total Fee"
                      format="C2"
                      textAlign="Left"
                    ></e-column>
                    <e-column
                      field="totalLevy"
                      headerText="Total Levy"
                      format="C2"
                      textAlign="Left"
                    ></e-column>
                    <e-column
                      field="invoiceDate"
                      headerText="Invoice Date"
                      textAlign="Left"
                      type="date"
                      format="MMM dd, yyyy"
                    ></e-column>
                  </e-columns>
                </ejs-grid>
              </div>
            </div>
          </div>
          <div v-show="isError" style="margin: 0 15px; line-height: 15px">
            <p ref="refErrorMessage" style="color: red; font-size: 12px"></p>
          </div>
          <div style="text-align: left; margin: 2%">
            <div class="e-card-separator"></div>
            <div class="form-row">
              <div class="form-row-input textbox-width" style="width: 90%">
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="Customer Note"
                  :multiline="true"
                  name="notes"
                  v-model="applicationRequestOrder.notes"
                />
              </div>
            </div>
            <div>
              <h4 class="title-color">Billing Information</h4>
            </div>
            <div class="e-card-separator"></div>
            <div class="form-row">
              <div class="form-row-input textbox-width" style="width: 40%">
                <!-- <scc-input-validator
                  :rules="[requiredRule]"
                  :value="applicationRequestOrder.referencePO"
                  @validate="(v) => (isPOValid = v)"
                > -->
                  <ejs-textbox
                  float-label-type="Always"
                  placeholder="PO"
                  :maxlength="250"
                  required
                  name="PO"
                  v-model="applicationRequestOrder.referencePO"
                />
                <!-- </scc-input-validator> -->
              </div>
            </div>
            <div class="form-row">
              <div
                class="form-row-input separated-textbox-width"
                style="width: 45%"
              >
                <scc-input-validator
                  :rules="[requiredRule]"
                  :value="applicationRequestOrder.firstName"
                  @validate="(v) => (isFirstNameValid = v)"
                >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="First Name*"
                    required
                    name="firstname"
                    v-model="applicationRequestOrder.firstName"
                    :maxlength="100"
                  />
                </scc-input-validator>
              </div>
              <div
                class="form-row-input separated-textbox-width"
                style="width: 45%"
              >
                <scc-input-validator
                  :rules="[requiredRule]"
                  :value="applicationRequestOrder.lastName"
                  @validate="(v) => (isLastNameValid = v)"
                >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="Last Name*"
                    required
                    name="lastname"
                    v-model="applicationRequestOrder.lastName"
                    :maxlength="100"
                  />
                </scc-input-validator>
              </div>
            </div>
            <div class="form-row">
              <div class="form-row-input textbox-width" style="width: 90%">
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="Company Name"
                  name="company"
                  v-model="applicationRequestOrder.company"
                  :maxlength="250"
                />
              </div>
            </div>
            <div class="form-row">
              <div
                class="form-row-input separated-textbox-width"
                style="width: 25%"
              >
                <ejs-textbox
                  ref="phone"
                  float-label-type="Always"
                  placeholder="Phone"
                  :value="applicationRequestOrder.phone"
                  :maxlength="12"
                  @input="formatPhoneNumber($event.value)"
                />
              </div>
              <div
                class="form-row-input separated-textbox-width"
                style="width: 30%"
              >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="Applicant Email"
                    required
                    name="emailaddress"
                    v-model="applicationRequestOrder.emailAddress"
                    readonly="true"
                    :maxlength="256"
                  />
              </div>
              <div
                class="form-row-input separated-textbox-width"
                style="width: 35%"
                v-if="applicationRequestOrder.emailAddress"
              >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="CC To"
                    required
                    name="emailaddress"
                    v-model="applicationRequestOrder.ccto"
                    :maxlength="256"
                  />
              </div>
              <div
                class="form-row-input separated-textbox-width"
                style="width: 35%"
                v-if="!applicationRequestOrder.emailAddress"
              >
                <scc-input-validator
                  :rules="[requiredRule]"
                  :value="applicationRequestOrder.emailAddress"
                  @validate="(v) => (isEmailAddressValid = v)"
                >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="CC To**"
                    required
                    name="emailaddress"
                    v-model="applicationRequestOrder.ccto"
                    :maxlength="256"
                  />
                </scc-input-validator>
              </div>
            </div>
            <div class="form-row">
              <div class="form-row-input textbox-width" style="width: 80%">
                <scc-input-validator
                  :rules="[requiredRule]"
                  :value="applicationRequestOrder.address"
                  @validate="(v) => (isAddressValid = v)"
                >
                  <ejs-autocomplete
                    :dataSource="melissaAddresses"
                    placeholder="Address*: "
                    :fields="addressAutocompleteFields"
                    ref="billingAddressAutocomplete"
                    :minLength="addressAutocompleteMinLength"
                    :filtering="onAddressAutocompleteFiltering"
                    :change="onAddressSelection"
                    float-label-type="Always"
                    cssClass="required"
                    v-model="applicationRequestOrder.address"
                  ></ejs-autocomplete>
                </scc-input-validator>
              </div>
            </div>
            <div class="form-row">
              <div class="form-row-input area-textbox-width">
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="City"
                  name="city"
                  v-model="applicationRequestOrder.city"
                  :maxlength="50"
                />
              </div>
              <div class="form-row-input area-textbox-width">
                <ejs-dropdownlist
                  float-label-type="Always"
                  :data-source="province"
                  sortOrder="Ascending"
                  :fields="provinceFields"
                  v-model="applicationRequestOrder.province"
                  name="province"
                  placeholder="Select a Province"
                  :maxlength="50"
                >
                </ejs-dropdownlist>
              </div>
              <div class="form-row-input postalcode-textbox-width">
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="Postal Code"
                  name="postcode"
                  v-model="applicationRequestOrder.postCode"
                  :maxlength="10"
                />
              </div>
            </div>
            <div v-show="isPayByCreditCard">
              <div style="display: flex">
                <h4 class="title-color" style="margin-right: 50%">
                  Payment Details
                </h4>
                <div class="colright50 logos">
                  <img src="@/assets/payments/ca_visa.png" alt="Visa" />
                  <img src="@/assets/payments/ca_mc.png" alt="Mastercard" />
                  <img
                    src="@/assets/payments/ca_amex.png"
                    alt="American Express"
                  />
                  <img
                    src="@/assets/payments/ca_visadebit.png"
                    alt="Visa Debit"
                  />
                  <img
                    src="@/assets/payments/ca_mcdebit.png"
                    alt="Mastercard Debit"
                  />
                </div>
              </div>
              <div class="e-card-separator"></div>
              <div class="form-row">
                <div
                  class="form-row-input separated-textbox-width"
                  style="width: 30%"
                >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="Card Holder*"
                    name="cardholdername"
                    required
                    v-model="applicationRequestOrder.cardholderName"
                  />
                </div>
                <div
                  class="form-row-input separated-textbox-width"
                  style="width: 30%"
                >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="Card Number*"
                    name="maskedpan"
                    required
                    :maxlength="250"
                    v-model="applicationRequestOrder.maskedPan"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-row-input separated-textbox-width">
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="Expiry Date* (mm/yy)"
                    required
                    name="expdate"
                    @input="formatExpiryDate($event.value)"
                    :maxlength="5"
                    v-model="applicationRequestOrder.expDate"
                  />
                </div>
                <div class="form-row-input separated-textbox-width">
                  <div style="display: flex; flex-direction: row">
                    <ejs-textbox
                      float-label-type="Always"
                      placeholder="Card Security Code*"
                      name="cvd"
                      v-model="applicationRequestOrder.cvd"
                    />
                    <ejs-button v-on:click.native="onTipMessage">?</ejs-button>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="isPayByCredit">
              <div style="display: flex">
                <h4 class="title-color" style="margin-right: 50%">
                  Payment Details
                </h4>
              </div>
              <div class="e-card-separator"></div>
              <div class="form-row">
                <div
                  class="form-row-input separated-textbox-width"
                  style="width: 30%"
                >
                <p>Your application has been submitted for processing in priority order. </p>
                </div>
              </div>
            </div>
            <div v-show="isPayByCheck">
              <div style="display: flex">
                <h4 class="title-color" style="margin-right: 50%">
                  Payment Details
                </h4>
              </div>
              <div class="e-card-separator"></div>
              <div class="form-row">
                <div
                  class="form-row-input separated-textbox-width"
                  style="width: 80%"
                >
                  <p>Application will be submitted once payment has been received.</p>
                  <p>Please make cheques payable to Safety Codes Council.</p>
                  <p>If you would like to pay by EFT, please contact accounting@safetycodes.ab.ca
                    for EFT information.</p>
                  <p>Please note: Safety Codes Council does not accept e-transfers.</p>

                </div>
              </div>
            </div>

            <div class="e-card-separator"></div>
            <div style="text-align: right">
              <!-- <ejs-button cssClass="e-info"
                  v-on:click.native="onSubmit">Process Transaction</ejs-button> -->
              <form @submit.prevent="onSubmit">
                <ejs-progressbutton
                  ty
                  :content="content"
                  type="submit"
                  ref="progressbutton"
                  cssClass="e-info"
                  style="height: 35px; width: 40%"
                  :enableProgress="true"
                  :animationSettings="animationSettings"
                  :begin="begin"
                  :end="end"
                  :click="onSubmit"
                  :duration="duration"
                  v-show="isAvailableToCheckOut"
                ></ejs-progressbutton>
              </form>
              <ejs-button
                cssClass="e-danger"
                style="height: 35px; width: 10%; margin: 10px"
                v-on:click.native="onCancelClick"
                >Cancel</ejs-button
              >
            </div>
            <div v-show="showTip">
              <fieldset>
                <legend>Help Message</legend>
                <p ref="refTipMessage"></p>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from '@syncfusion/ej2-vue-grids';

import {
  TextBoxPlugin,
  MaskedTextBoxPlugin,
  NumericTextBoxPlugin,
} from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin, RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { DialogUtility } from '@syncfusion/ej2-popups';
import {
  DropDownListPlugin,
  AutoCompletePlugin,
} from '@syncfusion/ej2-vue-dropdowns';
import { ProgressButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons';
import {
  GET_MELISSA_ADDRESSES,
  GET_USER_PROFILES_BY_ID,
  GET_USER_COMAPNY_DATA_BY_ID,
  GET_PROVINCES,
} from '@/modules/user-accounts/store';
import appConfig from '../../../app.config';
import {
  FETCH_SHOPPING_CART_BY_USER_ID,
  FETCH_SHOPPING_CART_PAYMENT_METHODS,
  REMOVE_INVOICE_FROM_SHOPPING_CART,
  REQUEST_PAY,
  POST_SHOPPING_CART,
} from '../store';

import SccInputValidator from '../../../components/base/scc-input-validator.vue';

Vue.use(GridPlugin);
Vue.use(TextBoxPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(AutoCompletePlugin);
Vue.use(DropDownListPlugin);
Vue.use(ProgressButtonPlugin);
Vue.use(DialogUtility);

export default {
  name: 'Checkout',
  components: {
    SccInputValidator,
  },
  data() {
    return {
      spin: false,
      pageSettings: { pageSize: 10 },
      toolbarOptions: ['Search'],
      invoiceToRemove: null,
      DialogObj: null,
      user: null,
      userCompany: null,
      province: [],
      commands: [
        {
          type: 'Delete',
          buttonOption: {
            cssClass: 'e-flat deletebtn',
            iconCss: 'e-delete e-icons',
          },
        },
      ],
      melissaAddresses: [],
      addressAutocompleteMinLength: 3,
      addressAutocompleteFields: {
        value: 'Address.Address1',
        text: 'Address.Address',
      },
      melissaAddress1: '',
      melissaCountry: 'CA',
      showTip: false,
      returnOrder: null,
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      isError: false,
      isFirstNameValid: false,
      isLastNameValid: false,
      isEmailAddressValid: false,
      isAddressValid: false,
      // isPOValid: false,
      provinceFields: {
        text: 'provinceName',
        value: 'provinceName',
        groupBy: 'countryName',
      },
      position: { X: 'Right', Y: 'Top' },
      applicationRequestOrder: {
        firstName: '',
        lastName: '',
        company: '',
        address: '',
        city: '',
        province: '',
        postCode: '',
        country: 'Canada',
        phone: '',
        fax: '',
        emailAddress: '',
        maskedPan: '',
        cvd: '',
        expDate: '',
        cardholderName: '',
        notes: '',
        shoppingCartId: null,
        invoices: null,
        referencePO: null,
        ccto: '',
      },
      animationSettings: { effect: 'SlideUp', duration: 500, easing: 'linear' },
      spinSettings: { position: 'Center' },
      content: 'Process Transaction',
      duration: 6500,
      dateMarker: 'Expiry Date:',
      dateFormat: 'yyyy-MM-dd',
      tooltipPosition: 'top left',
      pos: null,
      tooltipContent:
        '<h3 class="cvdTitle" id="cvdTitleId">CVD - Card Validation Digits</h3><h4 class="cvdSubtitle">Visa, Mastercard and Gift Cards</h4>'
        + '<div class="cvdText">The CVD appears on the back your credit card, it is the last three digits printed on the signature panel. These digits should not appear anywhere else on the card.</div>'
        + '<h4 class="cvdSubtitle">American Express</h4>'
        + '<div class="cvdText">The CVD appears on the front of your credit card.  It is the printed four digits that appear above and to the right of the embossed card number.  On OPTIMA cards the CVD appears above and to the left of the embossed card number.</div>',
    };
  },
  created() {
    this.getShoppingCartByUserId();
    this.getPymentMethods();
    this.getUserProfilesById();
    this.getProvinces();
  },
  mounted() {

  },
  computed: {
    userId() {
      return this.$store.getters.loggedUser
        ? this.$store.getters.loggedUser.id
        : null;
    },
    shoppingCart() {
      return this.$store.getters.getShoppingCartByUserId;
    },
    invoices() {
      const invs = [];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.pos = '';
      this.shoppingCart.shoppingCartItems.forEach((element) => {
        invs.push(element.cartInvoice);
        if (element.cartInvoice.referencePO) {
          this.pos += `${element.cartInvoice.referencePO}; `;
        }
      });
      return invs;
    },
    withAvilableCart() {
      return !!this.shoppingCart;
    },
    paymentMethods() {
      return this.$store.getters.getShoppingCartPaymentMethods;
    },
    isPayByCreditCard() {
      return this.shoppingCart.checkOutMethod === 'Credit Card';
    },
    isPayByCredit() {
      return this.shoppingCart.checkOutMethod === 'Credit';
    },
    isPayByCheck() {
      return this.shoppingCart.checkOutMethod === 'Cheque' || this.shoppingCart.checkOutMethod === 'EFT';
    },
    isAvailableToCheckOut() {
      return this.shoppingCart.totalShoppingAmount > 0;
    },
  },
  watch: {
    pos(nval, oval) {
      if (nval !== oval) {
        this.applicationRequestOrder.referencePO = nval;
      }
    },
    userId(val) {
      if (val) {
        this.getShoppingCartByUserId();
        this.getPymentMethods();
        this.getUserProfilesById();
      }
    },
  },
  methods: {
    notify(type, message) {
      this.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
    formatPhoneNumber(val) {
      if (val?.length === 10 && parseInt(val, 0) && !val.includes('-')) {
        this.applicationRequestOrder.phone = `${val.slice(0, 3)}-${val.slice(3, 6)}-${val.slice(6)}` ?? null;
      } else {
        this.applicationRequestOrder.phone = val ?? null;
      }
    },
    formatExpiryDate(val) {
      if (val?.length === 4 && parseInt(val, 0) && !val.includes('/')) {
        this.applicationRequestOrder.expDate = `${val.slice(0, 2)}/${val.slice(2, 4)}` ?? null;
      } else {
        this.applicationRequestOrder.expDate = val ?? null;
      }
    },
    async getProvinces() {
      try {
        await this.$store.dispatch(GET_PROVINCES);
        this.province = this.$store.getters.provinces;
      } catch (err) {
        console.error(err);
      }
    },
    async getUserProfilesById() {
      try {
        if (this.userId) {
          const { userId } = this;
          await this.$store.dispatch(GET_USER_PROFILES_BY_ID, { userId });
          await this.$store.dispatch(GET_USER_COMAPNY_DATA_BY_ID, { userId });
          if (this.$store.getters.userCompanyDatabyID !== null) {
            this.userCompany = this.$store.getters.userCompanyDatabyID;
          }
          this.user = this.$store.getters.userProfilesbyID;
          if (this.user) {
            this.applicationRequestOrder.emailAddress = this.user.email;
            if (appConfig.env !== 'PROD') {
              this.applicationRequestOrder.maskedPan = '5454545454545454';
              this.applicationRequestOrder.cardholderName = 'LEO XU';
              this.applicationRequestOrder.expDate = '01/22';
              this.applicationRequestOrder.cvd = '099';
              this.applicationRequestOrder.notes = 'Leo test Search Request Guest Payment.';
            }
            this.applicationRequestOrder.firstName = this.user.firstName;
            this.applicationRequestOrder.lastName = this.user.lastName;
            this.applicationRequestOrder.address = this.user.address;
            this.applicationRequestOrder.city = this.user.cityName;
            this.applicationRequestOrder.province = this.user.provinceName;
            this.applicationRequestOrder.postCode = this.user.postalCode;
            this.applicationRequestOrder.phone = this.user.phoneNumber;
          }
          if (this.userCompany) {
            this.applicationRequestOrder.company = this.userCompany.legalName;
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    onTipMessage() {
      this.$refs.refTipMessage.innerHTML = this.tooltipContent;
      this.showTip = !this.showTip;
    },
    onCancelClick() {
      this.DialogObj = DialogUtility.confirm({
        title: 'Cancel Payment',
        content:
        'Are you sure you want to exit the payment process?<br> You can make the payment later from the "My Financial Transactions" page.',
        okButton: { text: 'OK', click: this.cancelProcess },
        cancelButton: { text: 'Cancel', click: this.hideDeleteDialog },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: 'Zoom' },
      });
    },
    cancelProcess() {
      this.$router.push('/reports/transactions');
      this.DialogObj.hide();
    },
    async getShoppingCartByUserId() {
      try {
        if (
          this.userId !== null
          && this.userId !== ''
          && this.userId !== 'undefined'
        ) {
          const { userId } = this;
          if (userId) {
            await this.$store.dispatch(FETCH_SHOPPING_CART_BY_USER_ID, userId);
          }
        }
      } catch (error) {
        this.notify('Error', error.message);
      }
    },
    async getPymentMethods() {
      try {
        await this.$store.dispatch(FETCH_SHOPPING_CART_PAYMENT_METHODS);
      } catch (error) {
        this.notify('Error', error.message);
      }
    },
    async commandClick(args) {
      const invoice = args.rowData;
      // eslint-disable-next-line default-case
      switch (args.commandColumn.type) {
        case 'Delete':
          this.invoiceToRemove = invoice;
          this.DialogObj = DialogUtility.confirm({
            title: 'Remove Invoice From Shopping Cart',
            content: 'Are you sure you want to remove this invoice?',
            okButton: { text: 'OK', click: this.removeInvoice },
            cancelButton: { text: 'Cancel', click: this.hideDeleteDialog },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' },
          });
          break;
      }
    },
    async removeInvoice() {
      const { invoiceId } = this.invoiceToRemove;
      await this.$store
        .dispatch(REMOVE_INVOICE_FROM_SHOPPING_CART, invoiceId)
        .then(() => {
          this.hideDeleteDialog();
        })
        .catch((error) => {
          console.error(`postapplication_err:${error.Status}`);
          this.hideDeleteDialog();
          DialogUtility.alert(error.message);
        });
      await this.getPymentMethods();
      await this.getShoppingCartByUserId();
    },
    hideDeleteDialog() {
      this.DialogObj.hide();
    },
    async getMelissaAddresses() {
      try {
        const { melissaCountry } = this;
        const { address: melissaAddress1 } = this.applicationRequestOrder;
        await this.$store.dispatch(GET_MELISSA_ADDRESSES, {
          melissaAddress1,
          melissaCountry,
        });
        this.melissaAddresses = this.$store.getters.melissaAddresses;
      } catch (err) {
        console.error(err);
      }
    },

    onAddressAutocompleteFiltering(e) {
      e.preventDefaultAction = true;
      if (
        e.text.length
        >= this.$refs.billingAddressAutocomplete.ej2Instances.minLength
      ) {
        this.$refs.billingAddressAutocomplete.ej2Instances.showSpinner();
        this.applicationRequestOrder.address = e.text;
        // this.melissaCountry = this.$refs.country.ej2Instances.value;
        const { melissaCountry } = this;
        const { address: melissaAddress1 } = this.applicationRequestOrder;
        this.$store
          .dispatch(GET_MELISSA_ADDRESSES, {
            melissaAddress1,
            melissaCountry,
          })
          .then(() => {
            e.updateData(this.$store.getters.melissaAddresses);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    onAddressSelection(e) {
      const { itemData } = e;
      if (itemData.Address) {
        this.applicationRequestOrder.address = itemData.Address.Address1 || '';
        const line2 = itemData.Address.Address2 || '';
        if (line2) {
          this.applicationRequestOrder.address += ` ${line2}`;
        }
        this.applicationRequestOrder.city = itemData.Address.SubAdministrativeArea
          || itemData.Address.Locality
          || '';
        this.applicationRequestOrder.province = itemData.Address.AdministrativeArea || '';
        this.applicationRequestOrder.postCode = itemData.Address.PostalCode || '';
      }
    },
    begin() {
      this.content = 'Loading...';
    },
    end() {
      this.content = 'Process Transaction';
      this.duration = 15000;
    },
    async postShoppingCart() {
      const data = this.shoppingCart;
      await this.$store.dispatch(POST_SHOPPING_CART, data);
    },
    async onSubmit() {
      this.duration = 15000;
      try {
        this.isError = false;
        let notificationContent = '<b>Please double check required fields:</b>';
        if (this.shoppingCart.totalShoppingAmount <= 0) {
          notificationContent += '<li>Total Amount must > 0.</li>';
          this.isError = true;
        }
        if (
          this.shoppingCart.checkOutMethod === null
          || this.shoppingCart.checkOutMethod === ''
        ) {
          notificationContent += '<li>Payment method is required.</li>';
          this.isError = true;
        }
        // if (!this.isPOValid) {
        //   console.log('po', this.applicationRequestOrder.referencePO);
        //   notificationContent += '<li>PO is required.</li>';
        //   this.isError = true;
        // }
        if (!this.isFirstNameValid) {
          notificationContent += '<li>First Name Missing.</li>';
          this.isError = true;
        }
        if (!this.isLastNameValid) {
          notificationContent += '<li>Last Name Missing.</li>';
          this.isError = true;
        }
        if (!this.isEmailAddressValid && !this.applicationRequestOrder.emailAddress) {
          notificationContent += '<li>CC To Email Missing.</li>';
          this.isError = true;
        }
        if (!this.isAddressValid) {
          notificationContent += '<li>Address Missing.</li>';
          this.isError = true;
        }
        if (this.shoppingCart.checkOutMethod === 'Credit Card') {
          if (!this.applicationRequestOrder.cardholderName) {
            notificationContent += '<li>Card Holder Missing.</li>';
            this.isError = true;
          }
          if (!this.applicationRequestOrder.maskedPan) {
            notificationContent += '<li>Card Number Missing.</li>';
            this.isError = true;
          }
          if (!this.applicationRequestOrder.expDate) {
            notificationContent += '<li>Expiry Date Missing.</li>';
            this.isError = true;
          } else if (this.applicationRequestOrder.expDate.length !== 5) {
            notificationContent += '<li>Expiry Date Format Wrong.</li>';
            this.isError = true;
          }
          if (!this.applicationRequestOrder.cvd) {
            notificationContent += '<li>Card Security Code Missing.</li>';
            this.isError = true;
          }
        }
        if (this.isError) {
          this.duration = 2000;
          this.content = 'Validation Error ....';
          if (!notificationContent) {
            notificationContent = 'Error, during payment.';
          }
          this.$refs.refErrorMessage.innerHTML = notificationContent;
          this.notify('Error', notificationContent);
          return;
        }
        await this.postShoppingCart();
        this.applicationRequestOrder.invoices = this.invoices;
        this.applicationRequestOrder.shoppingCartId = this.shoppingCart.cartId;
        const order = this.applicationRequestOrder;
        const resp = await this.$store.dispatch(REQUEST_PAY, order);
        // console.log('Payment success: ', resp);
        this.returnOrder = resp;
        this.notify('Success', 'Payment made successfully');
        this.$router.push({
          name: 'Receipt',
          params: {
            id: this.returnOrder,
          },
        });
        // -- refresh shopping cart
        await this.getShoppingCartByUserId();
      } catch (error) {
        this.notify('Error', error.response.data.message);
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../../../assets/styles/eservices-base.css";
.scc-logo {
  float: left;
}
.header-text {
  text-align-last: center;
  padding: 13px 130px 8px 8px;
}
</style>
